export default "__VITE_ASSET__55e3827d__"